import React, { useEffect, useRef, useState } from 'react'
import temiIcon from '../../assets/images/temi_image.png'
import greenDot from '../../assets/icons/ic_greendot.svg'
import redDot from '../../assets/icons/ic_reddot.svg'
import batteryFull from '../../assets/icons/ic_batteryfull.svg'
import batteryThird from '../../assets/icons/ic_batterythird.svg'
import batteryHalf from '../../assets/icons/ic_batteryhalf.svg'
import batteryLow from '../../assets/icons/ic_batterylow.svg'
import wifiFull from '../../assets/icons/ic_wififull.svg'
import wifiHalf from '../../assets/icons/ic_wifihalf.svg'
import wifiLow from '../../assets/icons/ic_wifilow.svg'
import arrowRight from '../../assets/icons/ic_arrowright.svg'
import menuIcon from '../../assets/icons/ic_menu.svg'
import { db } from '../../firebase-config'
import { deleteDoc, doc, getDoc, updateDoc } from 'firebase/firestore'
import { useAtom } from 'jotai'
import { currentRobot } from '../store/DataStore'

const TaskModel = ({
    robotName,
    networkStatus,
    batteryAmount,
    wifiStatus,
    nextTasks,
    task,
    taskContent,
    status,
    taskId,
    taskLabel = "Current Task",
    isReadOnly = false
}) => {
    const [batteryIcon, setBatteryIcon] = useState(batteryFull);
    const [wifiIcon, setWifiIcon] = useState(wifiFull);
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef();
    const [savedRobot] = useAtom(currentRobot);
    const [pauseTitle, setPauseTitle] = useState("");

    useEffect(() => {
        const onChangeBatteryIcon = () => {
            if (batteryAmount > 90) {
                setBatteryIcon(batteryFull);
            } else if (batteryAmount < 90 && batteryAmount > 50) {
                setBatteryIcon(batteryThird);
            } else if (batteryAmount < 50 && batteryAmount > 20) {
                setBatteryIcon(batteryHalf);
            } else if (batteryAmount < 20) {
                setBatteryIcon(batteryLow);
            }
        }
        const onChangeWifi = () => {
            switch (wifiStatus) {
                case 'Good':
                    setWifiIcon(wifiFull);
                    break;
                case 'Okay':
                    setWifiIcon(wifiHalf);
                    break;
                case 'Poor':
                    setWifiIcon(wifiLow);
                    break;
                default:
                    setWifiIcon(wifiLow);
                    break;
            }
        };
        onChangeBatteryIcon();
        onChangeWifi();
    }, [batteryAmount, wifiStatus]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setShowMenu(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuRef]);

    const onPlayPauseTask = () => {
        console.log('Document ID is: ', taskId);
        setShowMenu(false);
        if (pauseTitle === "Pause Task") {
            updateTaskStatus(taskId, "paused");
        } else {
            updateTaskStatus(taskId, "active");
        }

    };
    

    const onCancelTask = () => {
        setShowMenu(false);
        updateTaskStatus(taskId, "canceled");
        updateRefreshStatus(savedRobot);
    };

    const updateRefreshStatus = async (savedRobot) => {
        const docPath = `Companies/Zeeno_Dev/Settings/${savedRobot}/Controller/actions`;
        const docRef = doc(db, docPath);
        try {
          await updateDoc(docRef, {
            is_refresh: true,
          });
        } catch (error) {
          console.error('error updated location: ', error);
        }
    }
    
    const updateTaskStatus = async (taskId, status) => {
        const collectionPath = `Companies/Zeeno_Dev/Actions/${savedRobot}/Logs`;
        try {
            const taskRef = doc(db, collectionPath, taskId);
            if (status === "canceled") {
                await deleteDoc(taskRef);
                console.log(`Document successfully deleted for taskId: ${taskId} in robot: ${savedRobot}`);
            } else if (status === "paused") {
                await updateDoc(taskRef, { 
                    status: status,
                    is_running: false
                });
                console.log(`Status successfully updated to '${status}' for taskId: ${taskId} in robot: ${savedRobot}`);
            }
            else if(status === "active"){
                await updateDoc(taskRef, { 
                    status: status,
                    is_running: true
                });
                console.log(`Status successfully updated to '${status}' for taskId: ${taskId} in robot: ${savedRobot}`);    
            }
        } catch (error) {
            console.error(`Error updating/deleting document for taskId: ${taskId} in robot: ${savedRobot}`, error);
        }
    };

    const getTaskStatus = async (taskId) => {
        const collectionPath = `Companies/Zeeno_Dev/Actions/${savedRobot}/Logs`;
        try {
            const taskRef = doc(db, collectionPath, taskId);
            const docSnapshot = await getDoc(taskRef);

            if (docSnapshot.exists()) {
                console.log(`Status for taskId: ${taskId} is '${docSnapshot.data().status}'`);
                
                return docSnapshot.data().status; // Returns the status of the task
            } else {
                console.log(`No document found for taskId: ${taskId}`);
                return null;
            }
        } catch (error) {
            console.error(`Error getting document for taskId: ${taskId}`, error);
            return null;
        }
    };

    return (
        <div className='mt-5 flex items-start gap-3'>
            <div className='w-full rounded-[28px] bg-[#8290F8] p-[1px] sm:rounded-[40px]'>
                <div className='flex w-full flex-col gap-5 rounded-[27px] bg-white p-4 sm:rounded-[39px] sm:p-5 lg:flex-row lg:flex-wrap lg:items-center lg:gap-4'>
                    <div className='flex min-w-0 items-center'>
                        <img src={temiIcon} alt='temilogo' className='h-10 sm:h-12' />
                        <div className='ml-4 min-w-0'>
                            <h1 className='truncate font-heebo text-lg font-medium text-[#273a84] sm:text-xl'>{robotName}</h1>
                            <div className='mt-1 flex items-center'>
                                <img src={networkStatus === 'Offline' ? redDot : greenDot} alt='dot' className='h-2.5' />
                                <span className='ml-2 font-heebo text-sm font-light text-gray-400'>{networkStatus}</span>
                            </div>
                        </div>
                    </div>
                    <div className='grid grid-cols-2 gap-4 sm:grid-cols-3 lg:flex lg:flex-1 lg:flex-wrap lg:items-start lg:gap-6'>
                        <div>
                            <div className='flex items-center'>
                                <img src={batteryIcon} alt='battery' className='h-5' />
                                <span className='ml-1 font-heebo text-base text-[#273a84] sm:text-lg'>{batteryAmount + '%'}</span>
                            </div>
                            <span className='mt-1 block font-heebo text-sm font-light text-gray-400'>Battery</span>
                        </div>
                        <div>
                            <div className='flex items-center'>
                                <img src={wifiIcon} alt='wifi' className='h-5' />
                                <span className='ml-1 font-heebo text-base text-[#273a84] sm:text-lg'>{wifiStatus}</span>
                            </div>
                            <span className='mt-1 block font-heebo text-sm font-light text-gray-400'>WIFI</span>
                        </div>
                        <div>
                            <span className='block font-heebo text-base text-[#273a84] sm:text-lg'>{task}</span>
                            <span className='mt-1 block font-heebo text-sm font-light text-gray-400'>{taskLabel}</span>
                        </div>
                        <div className='col-span-2 sm:col-span-3 lg:min-w-[220px] lg:flex-1'>
                            <span className='block break-words font-heebo text-base text-[#273a84] sm:text-lg'>{taskContent}</span>
                            <span className='mt-1 block font-heebo text-sm font-light text-gray-400'>Description</span>
                        </div>
                    </div>
                    <div className='flex items-center justify-between border-t border-[#E5E8FB] pt-4 lg:ml-auto lg:border-t-0 lg:pt-0'>
                        <span className='font-heebo text-lg text-[#3C5BD2] sm:text-xl lg:text-2xl'>{status}</span>
                        <img src={arrowRight} alt='arrowright' className='ml-4 h-4 sm:h-5' />
                    </div>
                </div>
            </div>
            {!isReadOnly && (
                <div className='relative flex-shrink-0'>
                    <img src={menuIcon} alt='menu' className='cursor-pointer pt-4' onClick={async () => {
                        setShowMenu(!showMenu);
                        const status = await getTaskStatus(taskId);
                        console.log("Task Status:", status);
                        if (status === 'active') {
                            setPauseTitle("Pause Task");
                        } else {
                            setPauseTitle("Resume Task");
                        }
                    }} />
                    {showMenu && (
                        <div ref={menuRef} className='absolute right-0 top-10 z-20 w-48 rounded-xl bg-[#DCE0FF] shadow-xl'>
                            {status !== 'Upcoming' && <button className='block px-4 py-3 font-heebo font-light text-lg text-gray-700 hover:bg-[#e7eaff] w-full text-left rounded-t-xl' onClick={onPlayPauseTask}>{pauseTitle}</button>}
                            <button className='block px-4 py-3 font-heebo text-lg text-red-500 hover:bg-[#e7eaff] w-full text-left rounded-b-xl' onClick={onCancelTask}>Cancel Task</button>
                        </div>
                    )}
                </div>
            )}

        </div>

    )
}



export default TaskModel
